import { createListingStepMachine } from '../../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { ShiftDetailsFormValues } from './types';

export const shiftDetailsMachine = createListingStepMachine<ShiftDetailsFormValues>(
  API_CALLS.patch,
  'msaasListingsState'
);
